import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { FaIdCard, FaUser, FaChild, FaPhone } from 'react-icons/fa';

const ViewGatepass = () => {
  const { id } = useParams();
  const [gatepass, setGatepass] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

 useEffect(() => {
  const fetchGatepass = async () => {
    try {
      const storedSessionId = localStorage.getItem("currentSessionId");

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/gatepasses/getGatepassById/${id}`,
        {
          params: { sessionId: storedSessionId }, 
        }
      );

      setGatepass(response.data);
      setLoading(false);
    } catch (error) {
      setError("Error fetching gatepass details");
      setLoading(false);
    }
  };

  fetchGatepass();
}, [id]);



  if (loading)
    return (
      <div className="flex items-center justify-center min-h-full bg-gray-100">
        <p className="text-lg font-semibold text-gray-600">Loading...</p>
      </div>
    );

  if (error)
    return (
      <div className="flex items-center justify-center min-h-full bg-gray-100">
        <p className="text-lg font-semibold text-red-500">{error}</p>
      </div>
    );

  return (
    <div className="min-h-full bg-gradient-to-r from-blue-50 to-blue-100">
      <div className="container mx-auto p-6">
        <div className="bg-white shadow-lg rounded-xl p-8">
          <h1 className="text-4xl font-bold text-blue-700 text-center mb-8">
            Gatepass Details
          </h1>

          {gatepass ? (
            <div className="space-y-8">
              {/* Gatepass Information */}
              <section>
                <div className="flex items-center space-x-4 mb-4">
                  <FaIdCard className="text-blue-500 text-3xl" />
                  <h2 className="text-2xl font-bold text-gray-800">
                    Gatepass Information
                  </h2>
                </div>
                <div className="bg-gray-50 rounded-lg p-4 shadow-sm">
                  <p className="text-gray-700">
                    <span className="font-semibold">Gatepass ID:</span>{' '}
                    {gatepass.gatepassID}
                  </p>
                  <p className="text-gray-700">
                    <span className="font-semibold">Issued At:</span>{' '}
                    {new Date(gatepass.issuedAt).toLocaleDateString()}
                  </p>
                </div>
              </section>

              {/* Guardian Details */}
              <section>
                <div className="flex items-center space-x-4 mb-4">
                  <FaUser className="text-blue-500 text-3xl" />
                  <h2 className="text-2xl font-bold text-gray-800">
                    Guardian Details
                  </h2>
                </div>
                <div className="flex items-center bg-gray-50 space-x-6">
                  {gatepass.guardian.image && (
                    <img
                      src={gatepass.guardian.image}
                      alt="Guardian"
                      className="w-28 h-28 rounded-full object-cover shadow-md border-2 border-blue-300"
                    />
                  )}
                  <div>
                    <p className="text-gray-700">
                      <span className="font-semibold">Name:</span>{' '}
                      {gatepass.guardian.name}
                    </p>
                    <p className="text-gray-700">
                      <span className="font-semibold">Relation:</span>{' '}
                      {gatepass.guardian.relation}
                    </p>
                    <p className="text-gray-700">
                      <span className="font-semibold">Phone:</span>{' '}
                      {gatepass.guardian.phone}
                    </p>
                  </div>
                </div>
              </section>

              {/* Children Details */}
              <section>
                <div className="flex items-center space-x-4 mb-4">
                  <FaChild className="text-blue-500 text-3xl" />
                  <h2 className="text-2xl font-bold text-gray-800">
                    Children Details
                  </h2>
                </div>
                <div className="bg-gray-50 rounded-lg p-4 shadow-sm">
                  <ul className="list-disc pl-6 text-gray-700 space-y-2">
                    {gatepass.children.map((child) => (
                      <li key={child._id}>
                        <span className="font-semibold">{child.name}</span> - Class{' '}
                        {child.class}({child.section})
                      </li>
                    ))}
                  </ul>
                </div>
              </section>
            </div>
          ) : (
            <div className="text-center text-lg text-gray-600">
              No gatepass details found.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewGatepass;
